<template>
    <modal name="brand-adver-register-modal" class="item-option-modal brand-adver-register-modal"
           :width="'60%'"
           :height="'auto'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="keymodal_title">
            <div class="out_title">브랜드 광고 등록</div>
        </div>
        <div class="pa20">
            <brand-write-component :brandType="'writeBrandAdver'"></brand-write-component>
            <div class="text_center pt20">
                <el-button type="primary" class="out_btn" @click="save()">저장</el-button>
                <el-button type="info" class="out_btn" @click="modalClose()">취소</el-button>
            </div>
        </div>
    </modal>
</template>

<script>
import util from '@/mixins/util';
import EventBus from "../../mixins/event-bus";
import BrandWriteComponent from "@/components/brand/BrandWriteComponent.vue";
export default {
    name: "BrandAdverRegisterModal",
    props: {
    },
    mixins: [],
    components: {
        BrandWriteComponent
    },
    computed: {},
    provide() {
        return {
        }
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {
        handlerBeforeOpen(event) {
        },
        handlerOpened() {
        },
        handlerBeforeClose() {
            EventBus.$emit('brandAdverGetList');
        },
        modalClose() {
            this.$modal.hide('brand-adver-register-modal');

        },
        async save() {
            EventBus.$emit('writeBrand')
        },


    }
}
</script>

<style scoped>

</style>
